import React from 'react';

import { Field } from 'react-form';

import { Checkbox } from 'primereact/checkbox';

import FieldMessage from './FieldMessage'

import { validateFromRule, getRuleForProperty } from '../../js/validation'


// this ia wrapper function for the prime react checkbox so it can work with react-form's form object
// make sure it is used with Form tags

// the reason this is done is because prime react's components are examples of controlled components
// they have a value set that binds to the state or props so that when that state or props is udated the component is re-rendered
// the onChange of the component needs to be handled to update the value of the state or props otherwise the user input will not be picked up

// this allows the value of the form to read and updated in the form
// pass in the field as the property name to bind and the label as what is displayed
// an optional validate function can be passed in to perform validation
/*
  <Form>
  {formApi => {
      return (
      <form>
          <div className=""p-grid">
              <div className="p-col-12">
                  <FieldCheckbox field={"PaidServicesProvided"} label={"Paid Services Provided"} />
              </div>
          </div>
      </form>
      )}
  }
  </Form>
*/
class FieldCheckbox extends React.Component {
    render() {
        let validationRule = {}
        if (this.props.validationRules) {
            validationRule = getRuleForProperty(this.props.validationRules, [this.props.field])
        }
        return (
            // Use the form field and your custom input together to create your very own input!
            // field is the property name that is bound to in the form
            // validate is a function used to validate the field
            <Field field={this.props.field} validate={this.validate}>
                {fieldApi => {
                    // fieldApi properties can found at https://react-form.js.org/#/custom-input
                    // Remember to pull off everything you dont want ending up on the element otherwise it will throw errors
                    // this extracts validate and field out of the props passed in and leaves ...rest to be the rest of the properties
                    // this way can pass in the extra properties to the prime react component
                    const { onBlur, onChange, validate, field, validationRules, showAsTextOnly, ...rest } = this.props
                    // value and setValue read and update value in the form
                    const { value, setValue, setTouched, error, warning, success } = fieldApi

                    return (
                        // React.Fragment used here because there always needs to a single root tag for a component and I didn't want to put a div incase it ruins formatting
                        // this allows the checkbox and label to be on the same level
                        <React.Fragment>
                            <Checkbox
                                {...rest}
                                checked={typeof this.props.checked === 'boolean' ? this.props.checked : value || false}
                                disabled={!!this.props.disabled}
                                onChange={e => {
                                    const newChecked = (typeof e === 'boolean') ? e : (e && typeof e.checked !== 'undefined' ? e.checked : (e && e.target ? e.target.checked : false));
                                    if (onChange) {
                                        // forward normalized boolean
                                        try { onChange(newChecked) } catch (err) { onChange(e) }
                                    } else {
                                        setValue(newChecked)
                                    }
                                    // only mark touched if this Field was registered with a field name
                                    if (field) {
                                        setTouched();
                                    }
                                }}>
                            </Checkbox>
                            <label  style={{ marginLeft: '8px' }} className={validationRule && validationRule.IsRequired && !showAsTextOnly ? 'required-field-label' : ''}>{this.props.label}</label>
                            {error ? <FieldMessage color="red" message={error} /> : null}
                            {!error && warning ? <FieldMessage color="orange" message={warning} /> : null}
                            {!error && !warning && success ? <FieldMessage color="green" message={success} /> : null}
                        </React.Fragment>
                    )
                }}
            </Field>

        )
        
    }

        /*
            generic validation handler for input field
            checks the validation rules
        */
        validate = value => {
            let validationResult = {}
            let validationRule = {}
            if (this.props.validationRules) {
                validationRule = getRuleForProperty(this.props.validationRules, [this.props.field])
                if (validationRule) {
                    validationResult = validateFromRule(validationRule, value)
                }
            } else {
                validationResult.success = ''
            }
            return validationResult
        }
    }

    export default FieldCheckbox



// WEBPACK FOOTER //
// ./src/components/common/FieldCheckbox.js